import { useSelector } from "react-redux";
import LeaderOrder from "./LeaderOrder";
import { useParams } from "react-router-dom";
import { CONSTANTS } from "client/utils/constants";

const LeaderOrderContainer = () => {
    
    const {requesttype} = useParams();
    const {
        transferOrderByIdData,
        afeOrderByIdData
    }:any = useSelector((state:any)=>({
        transferOrderByIdData: state.TransferOrderReducer.transferOrderByIdData,
        afeOrderByIdData: state.TransferReducer.afeOrderByIdData
    }))

    return <LeaderOrder requesttype = {requesttype} transferOrderByIdData = {requesttype === CONSTANTS.AFEREQUEST ? afeOrderByIdData : transferOrderByIdData }/>
}

export default LeaderOrderContainer;
